export default __webpack_public_path__ + "static/media/icon-twitter.23df5d42.svg";